import type { ComponentProps } from 'react';
import { Trash2 } from 'lucide-react';

interface Props extends ComponentProps<'span'> {
  status: string | null;
  deleted?: boolean;
}

const ApplicationStatus = ({ status, deleted }: Props) => {
  if (deleted)
    return (
      <p className="flex items-center gap-2 text-red-400">
        Soft deleted <Trash2 className="h-4 w-4" />
      </p>
    );
  if (!status) return ' - ';
  if (!status.length) return ' - ';

  return <span className="">{status.split('_').join(' ')}</span>;
};

export default ApplicationStatus;
